import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IBillOfMaterialRepository } from "./IBillOfMaterialRepository";
import { BillOfMaterial } from "src/app/models/Production/bill-of-material";
import { BOMFinishedReceiptReport } from "../../../models/Production/ReportModel/BOMFinishedReceiptReport";

@Injectable(
    {
        providedIn: "root"
    }
)
export class BillOfMaterialRepository extends GenericRepository<BillOfMaterial> implements IBillOfMaterialRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/BillOfMaterial', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }

        return this.Get('SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText).pipe(map(this.extractData), catchError(this.handleError));
    }

    SelectAll(): Observable<any> {
        return this.Get('SelectAllBOMProductNames').pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveRec(item: BillOfMaterial): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }

    SelectProductForBOM(productCode: string): Observable<ResponseModel> {
        return this.GetById('/SelectProductForBOM' + '/' + productCode).pipe(map(this.extractData), catchError(this.handleError));
    }

    NavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.Get('NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetRec(code: string): Observable<ResponseModel> {
        return this.Get('GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetRecForPO(code: string): Observable<ResponseModel> {
        return this.Get('GetRecForPO/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetRecForMR(code: string): Observable<ResponseModel> {
        return this.Get('GetRecForMR/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
}